module.exports = __webpack_public_path__ + "static/media/Cactus_IndigoFair-04.5113a817.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/illustrations/Cactus_IndigoFair-04.png
 ** module id = 462
 ** module chunks = 0
 **/